import type { LocationModel, LocationModelInput } from 'generated/types';

import { FhirResource } from './fhir-resource';

export type LocationValues = Pick<
  LocationRecord,
  'city' | 'country' | 'name' | 'region'
>;

export class LocationRecord extends FhirResource {
  protected model: LocationModel;

  public constructor(model: LocationModel) {
    super(model);
    this.model = model;
  }

  public get id() {
    return this.model.id;
  }

  public get name() {
    return this.model.name;
  }

  public set name(value: string | null | undefined) {
    this.model = { ...this.model, name: value };
  }

  public get city() {
    return this.model.address?.city;
  }

  public set city(value: string | null | undefined) {
    this.model = {
      ...this.model,
      address: { ...this.model.address, city: value },
    };
  }

  public get country() {
    return this.model.address?.country;
  }

  public set country(value: string | null | undefined) {
    this.model = {
      ...this.model,
      address: { ...this.model.address, city: value },
    };
  }

  public get region() {
    return this.model.address?.state;
  }

  public set region(value: string | null | undefined) {
    this.model = {
      ...this.model,
      address: { ...this.model.address, city: value },
    };
  }

  public getModelInput(values?: LocationValues): LocationModelInput {
    if (values) {
      // eslint-disable-next-line guard-for-in
      for (const key in values) {
        try {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          this[key] = values[key];
        } catch {
          // eslint-disable-next-line no-continue
          continue;
        }
      }
    }
    const cleaned = FhirResource.getCleanInput(this.model);
    return {
      ...cleaned,
    };
  }
}
